import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "native-base";
import { useMemo } from "react";
import { formatVerboseMonthDay } from "@madmedical/utils";
import InsulinMeasurementsTable from "../../organisms/InsulinMeasurementsTable";
import useResponsive from "../../util/useResponsive";
import ListHeader from "../../molecules/ListHeader";
import Paper from "../../atoms/Paper";
import InsulinMeasurementContentMobile from "./InsulinMeasurementContentMobile";
const DesktopLayout = ({ onEndReached, sections, onDeletePress, onEditPress, }) => {
    const lastIndex = sections.length - 1;
    if (!sections.length) {
        return null;
    }
    return (_jsx(_Fragment, { children: sections.map((section, index) => (_jsxs(Box, Object.assign({ width: "full", px: 6, py: 4 }, { children: [section.header && (_jsx(ListHeader, { title: section.header.title, badge: section.header.badge, variant: "inverted", size: "md", px: 0, pt: 0, pb: 0 })), _jsx(InsulinMeasurementsTable, { data: section === null || section === void 0 ? void 0 : section.data, onEndReached: index === lastIndex ? onEndReached : undefined, onDeletePress: onDeletePress, onEditPress: onEditPress })] }), `measurement-table-section-${index}`))) }));
};
const InsulinMeasurementList = ({ data, onEndReached, onDeletePress, onEditPress, }) => {
    const { isSmallScreen } = useResponsive();
    const sections = useMemo(() => {
        const groups = data.reduce((prev, measurement) => {
            const date = measurement.administeredAt
                ? formatVerboseMonthDay(measurement.administeredAt)
                : "";
            if (!prev[date]) {
                prev[date] = [];
            }
            prev[date].push(measurement);
            return prev;
        }, {});
        return Object.keys(groups).map((date) => ({
            header: {
                title: date,
                badge: groups[date].length,
            },
            data: groups[date],
        }));
    }, [data]);
    return (_jsx(Paper, Object.assign({ borderTopLeftRadius: 0, borderTopRightRadius: 0, width: "full", borderWidth: 0 }, { children: isSmallScreen ? (_jsx(InsulinMeasurementContentMobile, { sections: sections, onEndReached: onEndReached, onDeletePress: onDeletePress, onEditPress: onEditPress })) : (_jsx(DesktopLayout, { sections: sections, onEndReached: onEndReached, onDeletePress: onDeletePress, onEditPress: onEditPress })) })));
};
export default InsulinMeasurementList;
